<owl-carousel-o [options]="optionsDefault">
  <ng-container *ngFor="let tarj of carTarjeta; let i = index">
    <ng-template carouselSlide>
      <img  [src]="tarj.url_imagen_cartarjeta" [alt]="'Tarjetas admitidas'">
    </ng-template>
  </ng-container>
</owl-carousel-o>

